
import React, { useEffect, useState } from "react";
import "./index.scss";
function Gem(props) {
  const { name, descriptions } = props;
  const [gems, setGems] = useState();

  const takeOut = (arr) => {
    let str = "";
    const egx = /url\((\S+)\)/g;
    arr?.[0] && arr.forEach((item) => {
      item.type === "html" && (str += item.value);
    });
    str = str.replace(/<p>(.*?)<\/p>/g, "");
    let result = [];
    str.replace(egx, (a, b) => {
      if (b.match("https://steamcdn-a.akamaihd.net/apps/570/icons")) {
        result.push(b);
      }
    });
    setGems(result);
  };

  useEffect(() => {
    takeOut(descriptions);
    // eslint-disable-next-line
  }, []);

  return (
    <div className="acc-gem-container">
      <p className="acc-gem-name">{name}</p>
      {gems?.[0] && (
        <div className="acc-gem-unit-c">
          {gems?.[0] &&
            gems.map((item, index) => {
              return (
                <div key={index} className="acc-gem-unit">
                  <img src={item} alt="" />
                </div>
              );
            })}
        </div>
      )}
    </div>
  );
}









export default Gem;
